import type { Context } from '@nuxt/types';

export default ({ app }: Context, inject: (key: string, value: any) => void) => {
  const isReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;

  inject('isReducedMotion', isReducedMotion);
};
